import React, { Component } from "react";

export class DottedLoading extends Component {
    render() {
        return (
            <div className="snippet" data-title="dot-flashing">
                <div className="stage">
                    <div className="dot-flashing"> </div>
                </div>
            </div>
        );
    }
}
